<template>
  <div class="r-under-order">
    <div class="label-row" v-if="config.labels && config.labels.length > 0">
      <div class="status-container common-flex common-flex-wrap">
        <div
          v-for="(labelItem, labelIndex) in config.labels"
          :key="labelIndex"
          class="status common-hover common-flex common-align-center"
          :style="{
            color: getTextColor(labelItem.color),
            background: labelItem.color + '30',
            fontWeight: 'bold',
            padding: '5px 10px',
            marginRight: '0',
            marginBottom: '5px',
            position: 'relative'
          }"
        >
          <div style="padding: 0 4px" @click="changeTip">
              {{ labelItem.content }}
          </div>
          <Icon
          @click="() => delTips(labelItem)"
          style="display: block; font-size: 16px; cursor: pointer;"
          type="ios-close"
        />
        </div>
        <div
          style="background: #e6e8eb; color: #081938; padding: 0 10px; flex: 1; display: flex; margin-left: 0;"
          class="status statusgray common-hover common-flex common-align-center"
          @click="addTip"
        >
        </div>
      </div>
    </div>
    <div
      v-else
      class="label-row"
    >
      <div
        style="background: #e6e8eb; color: #081938; padding: 0 10px; width: 100%; display: flex;"
        class="status statusgray common-hover common-flex common-align-center"
        @click="addTip"
      >
        <div >{{ $t("cart.iconadd") }}</div>
      </div>
    </div>
    <div class="common-flex common-justify-between common-align-center">
      <Checkbox
        @on-change="changeCheck"
        :true-value="1"
        :false-value="0"
        v-model="config.check"
      ></Checkbox>
      <div style="margin: 0 10px">{{ index + 1 }}</div>
      <div class="product">
        <img :src="config.clothUrl" :alt="config.orderZhName" />
        <div class="product-name">
          <div>{{ config.orderZhName }}</div>
        </div>
      </div>

      <div
        class="
          product-code
          common-flex common-direction-column common-justify-center
        "
      >
        <Poptip @on-popper-show="clickCode(config)" word-wrap width="200" :content="valuation" class='priceTip'>
          <div class="code common-hover">{{ config.orderCode }}<div class="attr" v-if="config.cusOrderCode">{{ config.cusOrderCode }}</div></div>
        </Poptip>

        <div class="attr">
          {{ config.clothZhName }} |
          <span v-if="config.fabric">{{ config.fabric }} | </span
          >{{ config.pubDate }}
        </div>
        <div class="details">
          <span class="common-hover" @click="checkOptions"
            >{{ $t("cart.checkOptions") }} |</span
          >
          <span v-if="config.orderType!==9" class="common-hover" @click="handleCartEdit">{{
            $t("cart.edit")
          }}</span>
          <span v-if="config.orderType!==9" class="common-hover" @click="handleCartBuyAgain">{{
            $t("cart.buyAgain")
          }}</span>
          <span v-if="config.orderType!==9" class="common-hover" @click="preCommit(config.orderId)">{{
              $t("cart.preCommit")
            }}  |</span>
          <span class="common-hover" @click="deleteOrder"
          >{{ $t("cart.delete") }}</span
          >
        </div>
      </div>

      <div class="product-cate">
        <div class="nums-box common-flex">
          <div
            @click="move"
            class="common-hover"
            :style="config.isEdit == 1 ? {} : { opacity: '.7' }"
          >
            <Icon style="border-right: none" class="icons" type="md-remove" />
          </div>
          <div class="nums">{{ config.amount }}</div>
          <div
            @click="add"
            class="common-hover"
            :style="config.isEdit == 1 ? {} : { opacity: '.7' }"
          >
            <Icon style="border-left: none" class="icons" type="md-add" />
          </div>
        </div>

        <Checkbox
          v-if="config.amount == 1 && config.isAddProduct == 1"
          @on-change="changeAdd"
          :disabled="config.isEdit != 1"
          :true-value="1"
          :false-value="0"
          v-model="config.addProduct"
          >{{ $t("saveItems.add") }}</Checkbox
        >
      </div>

      <div v-if="config.orderType!==9" class="product-total common-flex">
        <div class="custom-made">{{ $t("saveItems.customMade") }}</div>
        <div v-if="config.orderType==9" class="custom-made">{{ config.custName }}</div>
        <div>
          <Input
            size="small"
            disabled
            v-model="config.custName"
            style="width: 150px"
          ></Input>
          <div
            @click="customerDetails"
            v-if="config.isEdit == 1"
            class="customer-info"
          >
            <span class="iconfont iconbianji"></span>
          </div>
        </div>
      </div>
      <div v-else class="product-total common-flex">
        <div class="custom-made">{{ config.custName }}</div>
      </div>

      <div class="product-price">
        <div class="options common-flex common-align-center common-flex-end">
          <div></div>
          {{ config.statusName }}
        </div>
        <div class="price">{{ config.price }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "r-under-order",
  data() {
    return {
      check: false,
      addPair: false,
      valuation:''
    };
  },
  props: {
    spinShow:Boolean,
    config: Object,
    index: Number,
    orderType: {
      default: "order",
      type: String,
    },
  },
  computed: {
    // 计算属性生成对比度更好的背景色
    statusStyle() {
      return {
        color: this.getTextColor(this.config.color),
        background: this.config.color + '30',
        fontWeight: 'bold',
        padding: '5px 10px',
      };
    },
  },
  methods: {
     ...mapActions([
      "getOrderFormulaAction", //订单号计价公式
       "preCommitAction" //计算单耗
    ]),
    // 方法：根据背景颜色自动调整文本颜色
    getTextColor(hex) {
      let r = parseInt(hex.slice(1, 3), 16);
      let g = parseInt(hex.slice(3, 5), 16);
      let b = parseInt(hex.slice(5, 7), 16);

      // 计算颜色亮度（0-255）
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;

      // 根据亮度自动调整文字颜色
      return brightness > 186 ? '#000000' : hex;
    },
    // 点击
    clickCode(e){
      // getOrderFormulaAction
      let that=this;
      this.valuation='loading...'
      this.getOrderFormulaAction(e.orderId).then(res=>{
        this.valuation = ''
        res.data.map(item=>{
          this.valuation = this.valuation + item.categoryName + ':\n' + item.formula +';\n\n'
        })
        if(undefined!==e.flPrice){
          const flInfoString = JSON.parse(e.flInfo)
            .map(item => `${item.flCode}(${item.flPrice})`)
            .join(' + ');
          this.valuation += that.$t('materialCostDetail',{flPrice:e.flPrice,flInfo:flInfoString})
          this.valuation += that.$t('materialCost',{totalPrice:e.price,flPrice:e.flPrice,cloth:e.clothZhName,clothPrice:(e.price.substring(1)-e.flPrice).toFixed(2)})
        }
      })
    },
    // 点击
    preCommit(e){
      // getOrderFormulaAction
      let that=this;
      that.$emit("showLoading", true);
      this.preCommitAction(e).then(res=>{
        this.$Message.success('success');
      }).finally(function () {
        that.$emit("showLoading", false);
      });
    },
    // 删除标签
    delTips(labelItem) {
      this.$Modal.confirm({
        title: this.$t("delMsg.tips"),
        content: this.$t("delMsg.content"),
        okText: this.$t("delMsg.y"),
        cancelText: this.$t("delMsg.n"),
        onOk: () => {
          // 确保标签对象具有父组件期望的orderId属性
          if (!labelItem.orderId) {
            labelItem.orderId = this.config.orderId;
          }
          this.$emit("delTips", labelItem);
        },
      });
    },
    // 修改备注标签
    changeTip() {
      this.$emit("changeTip", this.config);
    },
    // 新增备注
    addTip() {
      this.$emit("addTip", this.config);
    },
    // 修改是否追加西裤
    changeAdd(e) {
      this.$emit("changeAdd", e, this.config, this.index);
    },
    // 是否选中
    changeCheck(e) {
      this.$emit("changeCheck", e, this.config, this.index);
    },
    // 增加数量
    add() {
      if (this.config.isEdit == 1) {
        if (this.config.addProduct == 1) {
          //追加产品
          this.$Message.error(this.$t("cart.doChangeNum"));
        } else {
          this.$emit("add", this.config);
        }
      } else {
        this.$Message.error(this.$t("cart.noModify"));
      }
    },
    // 减少数量
    move() {
      if (this.config.isEdit == 1) {
        this.$emit("move", this.config);
      } else {
        this.$Message.error(this.$t("cart.noModify"));
      }
    },
    // 用户详情
    customerDetails() {
      this.$emit("customerDetails", this.config);
    },
    // checkOptions

    checkOptions() {
      this.$emit("checkOptions", this.config);
    },
    // 复制
    consumptionQuery() {
      this.$emit("consumptionQuery", this.config);
    },
    // 编辑
    handleCartEdit() {
      this.$emit("edit", this.config);
    },
    // 再次购买
    handleCartBuyAgain() {
      this.$emit("buyAgain", this.config);
    },
    //删除订单
    deleteOrder() {
      this.$Modal.confirm({
        title: this.$t("delMsg.tips"),
        content: this.$t("delMsg.content"),
        okText: this.$t("delMsg.y"),
        cancelText: this.$t("delMsg.n"),
        onOk: async () => {
          this.$emit("deleteOrder", this.config);
        },
      });
    },
    // 支票收入
    checkMasurement() {
      this.$emit("checkMasurement");
    },
    // 支票收入
    update() {
      this.$emit("update");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-input[disabled],
fieldset[disabled] .ivu-input {
  background-color: #fff;
  opacity: 1;
  cursor: not-allowed;
  color: #515a6e;
}
.express-input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #b4bac3;
  /* placeholder字体大小  */
  font-size: 12px;
  /* placeholder位置  */
  text-align: left;
}
.express-input {
  height: 24px;
  line-height: 24px;
  border: 1px solid #b4bac3;
  border-right: none;
  padding: 0 10px;
}
.r-under-order {
  width: 1110px;
  margin: 0 auto;
  padding: 0px 10px 20px;
  border-bottom: 1px solid #f0f0f0;
  font-family: Roboto;
  position: relative;
}

.label-container {
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
}

.status-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  left: 0;
  top: 0;
  z-index: 1;
  max-width: 100%;
  width: 100%;
  gap: 0;
}

.status {
  height: 20px;
  line-height: 20px;
  background: #fbf1e6;
  font-size: 10px;
  font-weight: 400;
  text-align: left;
  color: #d87508;
  position: relative;
  justify-content: flex-start;
  margin-right: 0;
  margin-bottom: 5px;
}

.status-after {
  display: none;
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-right: 20px solid transparent;
  right: -20px;
  top: 0;
  z-index: 2;
}

.statusgray::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-top: 20px solid #e6e8eb;
  border-right: 20px solid transparent;
  right: -20px;
  top: 0;
}

.product {
  width: 76px;
  height: 76px;
  display: flex;
  position: relative;
  margin-right: 15px;
  overflow: hidden;
  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    object-position: center center;
    cursor: pointer;
  }
}

.product-name {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 76px;
  height: 15px;
  line-height: 15px;
  background: rgba(8, 25, 56, 0.5);
  color: #fff;
  text-align: center;

  > div {
    font-size: 12px;
    transform: scale(0.83);
  }
}

.product-code {
  width: 295px;
  text-align: left;
  margin: 8px 0;
  .code {
    font-size: 14px;
    font-weight: 600;
    color: #081938;
    line-height: 16px;
  }
  .attr {
    font-size: 12px;
    font-weight: 400;
    color: #081938;
    line-height: 14px;
    margin: 5px 0;
  }
  .express {
    width: 237px;
    margin-bottom: 8px;
    .iconshangchuan {
      width: 36px;
      height: 24px;
      line-height: 24px;
      background: #0a4dcc;
      color: #fff;
      font-size: 12px;
      text-align: center;
    }
  }
  .details {
    font-size: 12px;
    font-weight: 400;
    text-decoration: underline;
    color: #0a4dcc;
    line-height: 14px;
  }
}

.product-cate {
  width: 220px;
  opacity: 1;
  font-size: 14px;
  font-family: Roboto, Roboto-Condensed;
  font-weight: Condensed;
  color: #081938;
  line-height: 16px;
  letter-spacing: 1px;
  text-align: left;
  .nums-box {
    margin-bottom: 12px;
    .icons {
      width: 32px;
      height: 32px;
      background: #e6e8eb;
      color: #081938;
      line-height: 32px;
      text-align: center;
      border: 1px solid #e6e8eb;
    }
    .nums {
      width: 50px;
      text-align: center;
      line-height: 30px;
      border-top: 1px solid #e6e8eb;
      border-bottom: 1px solid #e6e8eb;
    }
  }
}

.product-total {
  width: 300px;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  color: #081938;
  line-height: 16px;
  .custom-made {
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    color: #081938;
    line-height: 24px;
    margin-right: 8px;
  }
  .customer-info {
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    color: #0a4dcc;
    line-height: 14px;
    margin:5px 5px;
    float: right;
    cursor: pointer;
  }
}

.product-price {
  width: 180px;
  font-size: 14px;
  font-weight: 600;
  text-align: right;
  color: #081938;
  line-height: 16px;
  .options {
    color: #0a4dcc;
    font-size: 14px;
    line-height: 16px;
    > div {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      margin-right: 8px;
      background: #0a4dcc;
    }
  }
  .price {
    font-size: 16px;
    font-weight: 400;
    text-align: right;
    color: #081938;
    line-height: 19px;
    letter-spacing: 1px;
    margin-top: 20px;
  }
}

.product-status {
  width: 200px;
  text-align: right;
  color: #0a4dcc;
  .radio {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #0a4dcc;
    margin-right: 6px;
  }
}

.priceTip /deep/ .ivu-poptip-popper{
  width:400px!important;
}

.label-row {
  margin-bottom: 10px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/r-cart-order.vue